module.exports = __webpack_public_path__ + "img/img13.5ae2a441.svg";